/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Help Icon component.
 */
export const TopNavHelpIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19157)'>
        <circle cx='11.9998' cy='11.9998' r='11.0769' stroke={iconColor} strokeWidth='1.5' />
        <path d='M12.4609 15.5659H11.0077C11.0129 15.0659 11.0572 14.6571 11.1405 14.3394C11.2291 14.0164 11.3723 13.7222 11.5702 13.4565C11.7682 13.1909 12.0312 12.8888 12.3593 12.5503C12.5989 12.3055 12.8176 12.0763 13.0155 11.8628C13.2187 11.644 13.3827 11.4097 13.5077 11.1597C13.6327 10.9045 13.6952 10.5998 13.6952 10.2456C13.6952 9.88623 13.6301 9.57633 13.4999 9.31592C13.3749 9.0555 13.1874 8.85498 12.9374 8.71436C12.6926 8.57373 12.3879 8.50342 12.0234 8.50342C11.7213 8.50342 11.4348 8.55811 11.164 8.66748C10.8932 8.77686 10.6744 8.94613 10.5077 9.17529C10.3411 9.39925 10.2551 9.69352 10.2499 10.0581H8.80461C8.81503 9.46956 8.96086 8.96436 9.24211 8.54248C9.52857 8.12061 9.91399 7.79769 10.3984 7.57373C10.8827 7.34977 11.4244 7.23779 12.0234 7.23779C12.6848 7.23779 13.2473 7.35758 13.7109 7.59717C14.1796 7.83675 14.5364 8.1805 14.7812 8.62842C15.026 9.07113 15.1484 9.59717 15.1484 10.2065C15.1484 10.6753 15.052 11.1076 14.8593 11.5034C14.6718 11.894 14.4296 12.2612 14.1327 12.605C13.8359 12.9487 13.5208 13.2769 13.1874 13.5894C12.901 13.855 12.7083 14.1545 12.6093 14.4878C12.5103 14.8211 12.4609 15.1805 12.4609 15.5659ZM10.9452 18.0425C10.9452 17.8081 11.0182 17.6102 11.164 17.4487C11.3098 17.2873 11.5208 17.2065 11.7968 17.2065C12.078 17.2065 12.2916 17.2873 12.4374 17.4487C12.5833 17.6102 12.6562 17.8081 12.6562 18.0425C12.6562 18.2664 12.5833 18.4591 12.4374 18.6206C12.2916 18.7821 12.078 18.8628 11.7968 18.8628C11.5208 18.8628 11.3098 18.7821 11.164 18.6206C11.0182 18.4591 10.9452 18.2664 10.9452 18.0425Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19157'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TopNavHelpIcon;
